module.exports = __webpack_public_path__ + "c5d14c8906c14b3d5eac24cdd27e567f.fbx";